import { css, CSSResult } from 'lit'
import { csColorText } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const style: CSSResult = css`
  .policy {
    text-transform: capitalize;
  }

  .basket {  
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing05};
  }
  
  .basket-name {
    --cs-font-color: ${csColorText.headings};
  }

  .row-space-between {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  
  .row-content-end {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
`
